export default "__VITE_ASSET__CWvP4Hlh__"